<template>
  <div>
    <!-- Developers % Designers -->
    <div class="mdc-layout-grid demo-grid section-privacy-security">
      <h3
        id="feature11"
        class="feature mdc-typography--headline3 text-color mb-3"
      >
        Dezvoltatori și Designeri
      </h3>
      <p class="mdc-typography--body text-color font-weight-bold">
        Dezvoltăți produsul folosind API-ul nostru.
      </p>
      <div class="mdc-layout-grid__inner">
        <!-- ROW 1-->
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-8-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6
              class="mdc-typography--headline6 text-color position-relative"
              style="z-index:3;"
            >
              GRAPHQL & REST API
            </h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              Ghiduri pentru dezvoltatori
            </p>
            <figure class="image-feature11-item1" role=""></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color z-3">
              Resurse Brand
            </h6>
            <p
              class="mdc-typography--headline5 text-color font-weight-bold z-3"
            >
              Ghiduri de design
            </p>
            <figure class="image-feature11-item2" role="img-full"></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <!-- END ROW 1 -->
        <!-- ROW 2-->
        <div
          class="mdc-layout-grid__cell grid-cell-400 mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">
              MATERIAL DESIGN DOCS
            </h6>
            <p
              class="mdc-typography--headline5 text-color font-weight-bold w-50"
            >
              Surfverse is designed using the Material Design guidelines. These
              guidelines provide everything you need to know about how to design
              your app, from the user experience flow to visual design, motion,
              fonts, and more.
            </p>
            <figure class="image-feature11-item3" role="img-right"></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">
              Construit pentru antreprenori, iubit de investitori.
            </h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              "Simplitatea este complexitatea rezolvată." - Brâncuși
            </p>
            <figure class="image-feature11-item4" role="img"></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <!-- END ROW 2 -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  Developers: 'Developers'
}
</script>

<style>
.image-feature11-item1 {
  width: 100%;
  height: 85%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left;
  background-image: url(/img/developers/graphql-demo2.gif);
}
.image-feature11-item2 {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left;
  background-image: url(/img/developers/design.svg);
}
.image-feature11-item3 {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right;
  background-image: url(/img/developers/home-design-illustration.svg);
  bottom: -1rem !important;
}
</style>
